var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.68 68.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.677,19.942,14.614,43.055V68a2.435,2.435,0,0,0,2.435,2.435l17.057-.044a2.435,2.435,0,0,0,2.423-2.435V53.389a2.435,2.435,0,0,1,2.435-2.435h9.742a2.435,2.435,0,0,1,2.435,2.435V67.946a2.435,2.435,0,0,0,2.435,2.443l17.051.047A2.435,2.435,0,0,0,73.063,68V43.039l-28.057-23.1A1.855,1.855,0,0,0,42.677,19.942Zm44.328,15.71L74.28,25.163V4.08a1.827,1.827,0,0,0-1.827-1.827H63.93A1.827,1.827,0,0,0,62.1,4.08V15.132L48.476,3.92a7.306,7.306,0,0,0-9.285,0L.662,35.652a1.827,1.827,0,0,0-.244,2.572L4.3,42.943a1.827,1.827,0,0,0,2.574.248L42.677,13.7a1.855,1.855,0,0,1,2.329,0l35.8,29.489a1.827,1.827,0,0,0,2.572-.244l3.881-4.719a1.827,1.827,0,0,0-.259-2.577Z",
    transform: "translate(0.001 -2.254)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.af676a85.svg";
export { ForwardRef as ReactComponent };